// extracted by mini-css-extract-plugin
module.exports = {"tabs":"SGSTabs_tabs__1U5xX","indicator":"SGSTabs_indicator__2PYxv"};